import React, { useState, useEffect, useRef } from "react"
import styled from 'styled-components'
import { Spring, animated as a } from 'react-spring/renderprops'
import * as easing from 'd3-ease'

import lineMain from '../../../images/line_main.svg'

const Line = styled(a.path)`
  fill: none;
  stroke: #FFFFFF;
  stroke-width: 5;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
`

const Logo = ({ style, isVisible }) => {
  
  const pathRef = useRef(null)
  const [offset, setOffset] = useState(null);

  useEffect(() => {
    setOffset(pathRef.current.getTotalLength())
  }, [])

  return (
    <a.svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 112 496" style={{ enableBackground: "new 0 0 112 496", ...style}} xmlSpace="preserve">
      <image xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={lineMain} width="112" height="496" mask="url(#clipmask)" />
      <mask id="clipmask" maskUnits="objectBoundingBox">
        {offset ? (
          <Spring
            config={{ duration: 2000, easing: easing.easeCubicInOut }}
            from={{ dashOffset: offset }}
            to={{ dashOffset: isVisible ? offset * 2 : offset }}
          >
            {props => (
              <Line
                d="M77.7,496l6.8-4.6l4.5-10l1-6.5l-3.5-15.4l-7.5-20l-0.8-3.2l2.6-14L79,411l-8.7-12.7l-11.9-11.4l-6.7-8.5
                  l-3.6-9.2l-1.3-6.5l1.3-8.9l1.8-8.1l11.2-21.3l9.5-13.6l4.2-3l-0.3,3.7l-6,11.4l-10.9,12.3l-13.2,10.4l-17.9,11.8l-11.4,4l-8.7,0.5
                  L2,360.8l-1.7-1.3v-56.1l77.1,1.3l2.8-7.1l1.4-9.5l-0.3-6.5l-1.4-5l-4-8.2l-8-12.2l-5.8-11.9L59,232.7l0.3-8.6l2.6-10.2l6.2-26.6
                  l0.6-24.6l-0.4-14l-2.3-8.8l-2.8-5.6l-1.9-3.9l-1.5-7.2l-0.2-7.7l2.5-9.2L68.6,94L77,84l7.7-5.2l9.4-2.4l8.8,0.5l6.3,3.9l1.4,3.9
                  l-0.5,2.1l-6.8,3.3l-11.9-2l-27-19l-5.8-4l-9.7-6l-4.5-0.8l0.2,1.1l3.9,3.2l6.6,1.2l5.6-0.9l9.7-2.9l4.2-3l6.5-8.1l4-8.7l0.9-7.9
                  L85.1,20l-1.4-6.1l-2-6.4l-2-5.4l-1.5-2"
                strokeDashoffset={props.dashOffset}
                strokeDasharray={offset}
              />
            )}
          </Spring>
        ) : (
          <Line
            d="M77.7,496l6.8-4.6l4.5-10l1-6.5l-3.5-15.4l-7.5-20l-0.8-3.2l2.6-14L79,411l-8.7-12.7l-11.9-11.4l-6.7-8.5
              l-3.6-9.2l-1.3-6.5l1.3-8.9l1.8-8.1l11.2-21.3l9.5-13.6l4.2-3l-0.3,3.7l-6,11.4l-10.9,12.3l-13.2,10.4l-17.9,11.8l-11.4,4l-8.7,0.5
              L2,360.8l-1.7-1.3v-56.1l77.1,1.3l2.8-7.1l1.4-9.5l-0.3-6.5l-1.4-5l-4-8.2l-8-12.2l-5.8-11.9L59,232.7l0.3-8.6l2.6-10.2l6.2-26.6
              l0.6-24.6l-0.4-14l-2.3-8.8l-2.8-5.6l-1.9-3.9l-1.5-7.2l-0.2-7.7l2.5-9.2L68.6,94L77,84l7.7-5.2l9.4-2.4l8.8,0.5l6.3,3.9l1.4,3.9
              l-0.5,2.1l-6.8,3.3l-11.9-2l-27-19l-5.8-4l-9.7-6l-4.5-0.8l0.2,1.1l3.9,3.2l6.6,1.2l5.6-0.9l9.7-2.9l4.2-3l6.5-8.1l4-8.7l0.9-7.9
              L85.1,20l-1.4-6.1l-2-6.4l-2-5.4l-1.5-2"
            ref={pathRef}
            style={{ opacity: 0 }}
          />
        )}
      </mask>
    </a.svg>
  )
}

export default Logo